import React, { useCallback, type MouseEvent } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import {
	useAnalyticsEvents,
	fireUIAnalytics,
	type Attributes,
} from '@atlassian/jira-product-analytics-bridge';
import { LeftFooterButton } from '../../../common/ui/left-footer-button/index.tsx';
import messages from './messages.tsx';

type Props = {
	onShowFullList: () => void;
};

export const ShowFullListButton = ({ onShowFullList }: Props) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	const handleShowFullList = useCallback(
		(e: MouseEvent<HTMLElement>) => {
			const analyticsEvent = createAnalyticsEvent({
				eventType: 'UI',
				action: 'expanded',
				actionSubject: 'filterSearch',
				actionSubjectId: 'refinementBarFilterSearch',
			});

			const attributes: Attributes = {
				// If number of clicks is 0, button was actioned using the keyboard
				keyboard: e.detail === 0,
			};

			fireUIAnalytics(analyticsEvent, 'refinementBarFilterSearch', attributes);

			onShowFullList();
		},
		[createAnalyticsEvent, onShowFullList],
	);

	const message = formatMessage(messages.showFullListButtonText);

	return (
		<LeftFooterButton
			message={message}
			onClick={handleShowFullList}
			appearance="subtle-link"
			testId="jql-builder-basic-picker.ui.async-select.show-full-list-button.show-full-list-button"
			hasTooltip
		/>
	);
};

export default ShowFullListButton;
